export default "__VITE_ASSET__Ckc_SeLJ__"